import Help from "common/managers/help/Help";
export default new Help(window.DF_APP_HELP_PAGES);
